/**
 * AdminTable
 */

import styled from 'styled-components';
import { Table } from 'react-bootstrap';

const AdminTable = styled(Table)`
&&& {
  margin-bottom: 10px;
}

th, td {
  text-align: center;
  width: 15%;
  color: ${(p) => p.theme.grayLight};
  &:first-child {
    padding-left: 15px;
  }
  &.sub-groups {
    width: 0;
    padding-left: 0;
    text-align: left;
  }
  &.name {
    text-align: left;
    width: auto;
  }
  &.low-padding {
    padding-top: 3px;
    padding-bottom: 3px;
  }
  &.name-column {
    display: flex;
    flex-direction: column;
  }
  span.num {
    display: inline-block;
    width: 2em;
    text-align: right;
  }
  .color-block {
    margin-right: 0;
  }
  .w-25 {
    width: 25% !important;
  }
}
&& tbody > tr > td {
  vertical-align: middle;
}
`;

export default AdminTable;
